import { CommonOrderQtyModel } from "./common-order-qty.model";


export class ScheduleWiseOrderQtyModel extends CommonOrderQtyModel {
    schedule: string;
    
    constructor(schedule: string, plannedQuantity: number, completedQuantity: number, plannedCompletionDate: string) {
        super(plannedQuantity, completedQuantity, plannedCompletionDate);
        this.schedule = schedule;
    }
}
